import { combineReducers } from 'redux'

import notification from './notification'

export const reducer = combineReducers({
  notification: notification.reducer,
})

export default reducer
